import * as React from 'react';
import { st, classes } from './CoreDropdown.st.css';
import { CorePopover } from '../CorePopover';
import { CoreDropdownContent } from '../CoreDropdownContent';
import { filterDataProps } from '../../utils/FilterDataProps';
/**
 * Dropdown
 */
export class CoreDropdownComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onPopoverClick = this.onPopoverClick.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
    }
    handleClickOutside() {
        this.close();
    }
    _onExpandedChange(isExpanded) {
        if (this.props.onExpandedChange) {
            this.props.onExpandedChange(isExpanded);
        }
    }
    open() {
        this.props.setIsOpen(true);
        this._onExpandedChange(true);
    }
    onPopoverClick() {
        if (this.props.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }
    close() {
        if (this.props.isOpen) {
            this.props.setIsOpen(false);
            this._onExpandedChange(false);
        }
    }
    onOptionClick(option) {
        const { onSelect } = this.props;
        if (option) {
            onSelect(option);
            this.close();
        }
    }
    render() {
        const { options, children, disabled, forceContentElementVisibility, style: inlineStyles, id, readOnly, role, className, popoverProps, contentProps, isOpen, selectedId, } = this.props;
        const hasContent = Boolean((options && options.length) ||
            contentProps.fixedHeader ||
            contentProps.fixedFooter);
        const shown = forceContentElementVisibility ||
            (isOpen && !disabled && !readOnly && hasContent);
        return (React.createElement(CorePopover, { className: st(classes.root, { 'content-visible': shown }, className), onClickOutside: this.handleClickOutside, onKeyDown: !disabled && !readOnly ? this.props.onKeyDown : undefined, onClick: !disabled && !readOnly ? () => this.onPopoverClick() : undefined, shown: shown, style: inlineStyles, id: id, role: role, ...popoverProps, ...filterDataProps(this.props) },
            React.createElement(CorePopover.Element, null, children),
            React.createElement(CorePopover.Content, null,
                React.createElement(CoreDropdownContent, { className: classes.dropdownContent, options: options, selectedId: selectedId, onOptionClick: this.onOptionClick, onOptionHover: this.props.onOptionHover, ...contentProps }))));
    }
}
CoreDropdownComponent.displayName = 'CoreDropdown';
export const CoreDropdown = CoreDropdownComponent;
//# sourceMappingURL=CoreDropdown.js.map